import { ApiEndpoint } from '../../../app_constants/path';
import http from '../../app/http';

export const addLicense: (deviceId: string) => Promise<void> = async (deviceId) => {
  const url = `${ApiEndpoint.LICENSES}/${deviceId}`;

  return http.post(url);
};
